<template>
	<div class="chart">
		<div class="text">{{ text }}</div>
		<div class="content">
			<v-chart v-if="data.length" :option="option" />
			<template v-else>
				<div class="i-chart-empty"></div>
				<div class="placeholder">数据同步中…</div>
			</template>
		</div>
	</div>
</template>

<script>
import VChart from 'vue-echarts';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import { TooltipComponent, LegendComponent } from 'echarts/components';

export default {
	name: 'chart',
	components: {
		VChart,
	},
	props: {
		radius: {
			type: [Number, String, Array],
			default: _ => [0, '75%'],
		},
		name: {
			type: String,
			default: '',
		},
		data: {
			type: Array,
			default: _ => [],
		},
	},
	created() {
		use([CanvasRenderer, PieChart, TooltipComponent, LegendComponent]);
	},
	computed: {
		option() {
			const { radius, name, data } = this;
			const colors = [];
			const legendName = [];
			const level = 0.4 / (data.length - 1);
			data.forEach(({ name }, i) => {
				legendName.push(name);
				colors.push(`rgba(80, 145, 255, ${+(0.3 + i * level).toFixed(2)})`);
			});
			return {
				color: colors,
				tooltip: {
					trigger: 'item',
					formatter: '{a}<br/>{b} : {c} ({d}%)',
					backgroundColor: 'rgba(0, 0, 0, .6)',
					borderColor: 'transparent',
					padding: 6,
					textStyle: {
						color: '#fff',
						lineHeight: 20,
					},
				},
				legend: {
					bottom: 0,
					icon: 'circle',
					itemWidth: 14,
					textStyle: {
						color: '#666',
					},
					data: legendName,
				},
				series: [
					{
						name,
						type: 'pie',
						radius,
						center: ['50%', '45%'],
						data,
						label: {
							formatter: '{d|{d}%}\n{b|{b}}',
							rich: {
								d: {
									color: '#333',
									fontSize: 16,
									lineHeight: 22,
									fontWeight: 'bold',
								},
								b: {
									color: '#999',
									fontSize: 12,
									lineHeight: 18,
								},
							},
						},
					},
				],
			};
		},
		text() {
			const { data } = this;
			if (!data.length) return '数据同步中…';
			const { name, value } = data[data.length - 1];
			const total = data.reduce((a, b) => a + b.value, 0);
			const rate = +(value / total).toFixed(2) * 100;
			return `${name}居多，占比${rate}%`;
		},
	},
};
</script>

<style lang="less" scoped>
.chart {
	margin-top: 8px;
	.text {
		font-size: 12px;
		color: #666;
	}
	.content {
		height: 320px;
		display: flex;
		flex-direction: column;
		align-items: center;
		.i-chart-empty {
			margin-top: 48px;
		}
		.placeholder {
			font-size: 14px;
			color: #969799;
			line-height: 20px;
		}
	}
}
</style>
